import * as yup from 'yup';

const updateEmailValidationSchema = yup.object().shape({
  optInForUpdateEmail: yup
    .string()
    .email("Invalid email address")
    .required("Email is required")
    .test("not-same", "Email must be different from the previous one.", function (value) {
      // Accessing previousValue from the form's context
      const previousValue = this.options.context?.previousValue; // Using context
      return value !== previousValue; // Ensure new email is different
    }),
});


const otpValidationSchema = yup.object().shape({
  optInForUpdateEmail: yup
    .string()
    .email("Invalid email address")
    .required("Email is required")
    .test("not-same", "Email must be different from the previous one.", function (value) {
      // Accessing previousValue from the form's context
      const previousValue = this.options.context?.previousValue; // Using context
      return value !== previousValue; // Ensure new email is different
    }),
  otp: yup
    .string()
    .required("Otp is required")
    .length(6, "OTP must be exactly 6 digits"),
})

export {updateEmailValidationSchema, otpValidationSchema}